import Vue from 'vue';
import '@/forms';
import '@/tables';
import '@/notifications';

Vue.component('MainLayout', require('@/layouts/main').default);
